import React from "react"

type Props = {
    text: string,
    size?: "sm" | "lg"
}

export function TxItemText({ text, size = "sm" }: Props) {
    "font-display text-base font-semibold text-jacarta-700 dark:text-white";
    return <div>
        <h3 className={`${size === "sm" || "font-display font-semibold"} text-base text-jacarta-700 dark:text-white`}>
            {text}
        </h3>
    </div>
}